import styled from '../../Styles/themed-styled-components';

export const ValidationErrorText = styled.div`
  ${(props: any) => `color:  ${props.theme.colors.error};`}
`;
